<template lang="pug">
yz-dialog(v-model="showDialog" persistent max-width="500px")
  yz-card
    yz-dialog-normal-header(title="Archive inventory" @close="onClose")
    yz-dialog-normal-content.px-6.py-6
      .d-flex.align-start.gap-2
        yz-icon.mt-1(color="yz-danger-500" size="20") $yzi-alert-circle
        .yz-medium-body-md.text-neutral-700 {{ title }}
      .yz-regular-body-sm.text-neutral-700.mt-2.ml-7 {{ description }}
    yz-dialog-normal-actions
      yz-btn(size="lg" label="Close" @click="onClose")
</template>

<script>
export default {
  props: {
    value: {
      type: Boolean,
      default: false
    },
    type: {
      type: String,
      default: 'reservation'
    }
  },
  computed: {
    showDialog: {
      get() {
        return this.value
      },
      set(newValue) {
        this.$emit('input', newValue)
      }
    },
    title() {
      return this.type === 'preorder'
        ? 'This inventory currently has pre-orders'
        : 'This inventory currently has reservations'
    },
    description() {
      return this.type === 'preorder'
        ? 'Please cancel related pre-orders before archiving this inventory. Future pre-orders will be unavailable until this inventory is reactivated.'
        : 'Please cancel related reservations before archiving this inventory. Future reservations will be unavailable until this inventory is reactivated.'
    }
  },
  methods: {
    onClose() {
      this.showDialog = false
    }
  }
}
</script>
